import {
  FEATURES_REQUEST_SUCCESS,
} from './actionTypes';

// By default all features are disabled
// These features should not be renamed, as it will not match what is in the DB
// NOTE: When adding a feature please add it to ./pages/features/BestigeFeatures.jsx as well
const defaultFeatures = {
  customContent: false, // Allow customizable content to be displayed
  forms: false, // Allow forms to be displayed and edited
  liquidTemplates: false, // Allow content to be Liquid templates. Requires customContent.
  plans: false, // Allow plans to be displayed and edited
  richText: false, // Allow content to be rich text. Requires customContent.
  staticHtml: false, /* Allow content to be static html. Subcategory of customContent,
                        but does not require it. */
  theme: false, // Allow theme to be customized
  staticFiles: false, // Allow static images to be uploaded to s3 bucket.
};

export default function reducer(state = defaultFeatures, action) {
  let newState;
  switch (action.type) {
    case FEATURES_REQUEST_SUCCESS:
      // If there are no features defined for a carrier then set it to default features.
      if (Object.keys(action.features).length !== 0) {
        newState = { ...state };
        Object.keys(action.features).forEach((featureType) => {
          newState[featureType] = action.features[featureType];
        });
      } else {
        newState = { ...defaultFeatures };
      }
      return newState;
    default:
      return state;
  }
}

// actions
export function updateFeatures(features) {
  return {
    type: FEATURES_REQUEST_SUCCESS,
    features,
  };
}
